import React from "react";

export function parseMarkdownToReact(text: string): React.ReactNode[] {
  const lines = text.split("\n");
  const elements: React.ReactNode[] = [];
  let currentList: React.ReactNode[] = [];
  let listType: "ul" | "ol" | null = null;

  const flushList = (key: number) => {
    if (listType === "ul") {
      elements.push(<ul key={`ul-${key}`} className="list-disc pl-5 mb-4 space-y-1.5 text-foreground/80">{...currentList}</ul>);
    } else if (listType === "ol") {
      elements.push(<ol key={`ol-${key}`} className="list-decimal pl-5 mb-4 space-y-1.5 text-foreground/80">{...currentList}</ol>);
    }
    currentList = [];
    listType = null;
  };

  const parseInline = (lineText: string) => {
    const parts = lineText.split("**");
    return parts.map((part, idx) => {
      if (idx % 2 === 1) {
        return <strong key={idx} className="font-bold text-foreground">{part}</strong>;
      }
      return part;
    });
  };

  const parseHeading = (trimmed: string, idx: number) => {
    if (trimmed.startsWith("# ")) {
      return (
        <h1 key={idx} className="text-3xl font-extrabold text-brand-primary mt-8 mb-4 border-b border-border/40 pb-2">
          {parseInline(trimmed.slice(2))}
        </h1>
      );
    }
    if (trimmed.startsWith("## ")) {
      return (
        <h2 key={idx} className="text-2xl font-bold text-brand-primary mt-6 mb-3">
          {parseInline(trimmed.slice(3))}
        </h2>
      );
    }
    return (
      <h3 key={idx} className="text-xl font-bold text-brand-secondary mt-5 mb-2">
        {parseInline(trimmed.slice(4))}
      </h3>
    );
  };

  const parseListItem = (trimmed: string, idx: number) => {
    if (trimmed.startsWith("- ") || trimmed.startsWith("* ")) {
      if (listType !== "ul") {
        if (listType) flushList(idx);
        listType = "ul";
      }
      currentList.push(<li key={idx} className="text-sm md:text-base">{parseInline(trimmed.slice(2))}</li>);
    } else {
      if (listType !== "ol") {
        if (listType) flushList(idx);
        listType = "ol";
      }
      const content = trimmed.replace(/^\d+\.\s/, "");
      currentList.push(<li key={idx} className="text-sm md:text-base">{parseInline(content)}</li>);
    }
  };

  const processLine = (line: string, idx: number) => {
    const trimmed = line.trim();
    if (!trimmed) {
      if (listType) flushList(idx);
      return;
    }

    if (trimmed.startsWith("#") && /^#{1,3}\s/.test(trimmed)) {
      if (listType) flushList(idx);
      elements.push(parseHeading(trimmed, idx));
    } else if (trimmed.startsWith("- ") || trimmed.startsWith("* ") || /^\d+\.\s/.test(trimmed)) {
      parseListItem(trimmed, idx);
    } else {
      if (listType) flushList(idx);
      elements.push(
        <p key={idx} className="text-foreground/85 text-base leading-relaxed mb-4">
          {parseInline(trimmed)}
        </p>
      );
    }
  };

  lines.forEach((line, idx) => processLine(line, idx));

  if (listType) flushList(lines.length);
  return elements;
}
